export default __webpack_public_path__ + "static/media/shubham.d9b59e29.svg";